var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.widgetComponent)?_c(_vm.widgetComponent,_vm._b({tag:"component",attrs:{"endpoint":_vm.endpoint,"hidden-ride-types":_vm.hiddenRideTypes,"selected-tab":_vm.selectedTab,"stripe-key":_vm.stripeKey}},'component',_vm.$attrs,false)):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }